import gql from 'graphql-tag';

export default gql`
  mutation updateFile($organisationId: String!, $assetFileId: String!, $input: AssetFileInput!) {
    updateFile(organisationId: $organisationId, assetFileId: $assetFileId, input: $input) {
      assetFileId
      type
      status
      sourceUrl
    }
 }
`;